import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations, LANGS } from './translations';

const STORAGE_KEY = 'vb_lang';
const LanguageContext = createContext(null);

const lookup = (obj, path) => path.split('.').reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return LANGS.some(l => l.code === saved) ? saved : 'en';
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dataset.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const setLang = (code) => {
      localStorage.setItem(STORAGE_KEY, code);
      setLangState(code);
    };
    const t = (key, vars) => {
      let text = lookup(translations[lang], key);
      if (text === undefined) text = lookup(translations.en, key);
      if (typeof text !== 'string') return text ?? key;
      if (vars) Object.entries(vars).forEach(([k, v]) => { text = text.replace(`{${k}}`, v); });
      return text;
    };
    return { lang, setLang, t, langs: LANGS };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
